export const serverError = {
  title: 'An unpredictable error occurred on the server. It will be fixed soon',
  reloadPage: 'Refresh the page',
  goMain: 'Back to the main',
};
export default serverError;